import { render } from "./MyWidgets.vue?vue&type=template&id=34b218b2&scoped=true"
import script from "./MyWidgets.vue?vue&type=script&lang=js"
export * from "./MyWidgets.vue?vue&type=script&lang=js"

import "./MyWidgets.vue?vue&type=style&index=0&id=34b218b2&scoped=true&lang=css"
import "./MyWidgets.vue?vue&type=style&index=1&id=34b218b2&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b218b2"]])

export default __exports__